import React from "react";

import Round from "./round";
import Square from "./square";
import Aviator from "./aviator";
import Cyber from "./cyber";

export default function glasses(props: {
  style: string;
}): React.ReactElement | null {
  const { style } = props;
  switch (style) {
    case "round":
      return <Round />;
    case "square":
      return <Square />;
    case "aviator":
      return <Aviator />;
    case "cyber":
      return <Cyber />;
    case "none":
    default:
      return null;
  }
}
